import React from 'react';

const MyBuyers = () => {
    return (
        <div>
            My Buyers
        </div>
    );
};

export default MyBuyers;